export default {
    namespaced: true,
    state: {
        eventId: null,
        criterias: [],
        rounds: [],
        categories: [],
        selectedCategoryFilter: null,
        loading: false,
    },
    mutations: {
        setCategories(state, items) { state.categories = items; },
        setCriterias(state, items) { state.criterias = items; },
        setJudges(state, items) { state.judges = items; },
        setRounds(state, items) { state.rounds = items; },
        setEventId(state, id) { state.eventId = id; },
        setLoading(state, value) { state.loading = value; },
        setSelectedCategoryFilter(state, value) { state.selectedCategoryFilter = value; },

        // Rounds
        addRound(state, round) { state.rounds.push(round); },
        updateRoundItem(state, round) {
            const idx = state.rounds.findIndex(r => r.id === round.id);
            if (idx !== -1) state.rounds.splice(idx, 1, round);
        },
        removeRound(state, id) { state.rounds = state.rounds.filter(r => r.id !== id); },

        // Criteria
        addCriterion(state, c) { state.criterias.push(c); },
        updateCriterionItem(state, c) {
            const idx = state.criterias.findIndex(x => x.id === c.id);
            if (idx !== -1) state.criterias.splice(idx, 1, c);
        },
        removeCriterion(state, id) { state.criterias = state.criterias.filter(c => c.id !== id); },

        // Judges
        addJudge(state, j) { state.judges.push(j); },
        updateJudgeItem(state, j) {
            const idx = state.judges.findIndex(x => x.id === j.id);
            if (idx !== -1) state.judges.splice(idx, 1, j);
        },
        removeJudge(state, id) { state.judges = state.judges.filter(j => j.id !== id); },
        setJudgeInvited(state, id) {
            const j = state.judges.find(x => x.id === id);
            if (j) j.invitationSent = true;
        },

        reset(state) {
            state.eventId = null;
            state.criterias = [];
            state.judges = [];
            state.rounds = [];
            state.categories = [];
            state.selectedCategoryFilter = null;
            state.loading = false;
        },
    },
    actions: {
        async fetchCategories({ commit, state }, eventId) {
            if (state.categories.length) return;
            const nominationsService = (await import('@/services/nominations')).default;
            commit('setLoading', true);
            try {
                const res = await nominationsService.getCategories(eventId);
                commit('setCategories', Array.isArray(res.data) ? res.data : []);
            } finally {
                commit('setLoading', false);
            }
        },
        async fetchCriteria({ commit, state }) {
            if (state.criterias.length) return;
            const nominationsService = (await import('@/services/nominations')).default;
            commit('setLoading', true);
            try {
                const res = await nominationsService.getCriteria();
                commit('setCriterias', Array.isArray(res.data) ? res.data : []);
            } finally {
                commit('setLoading', false);
            }
        },
        async fetchJudges({ commit, state }, eventId) {
            if (state.judges.length) return;
            const nominationsService = (await import('@/services/nominations')).default;
            commit('setLoading', true);
            try {
                const res = await nominationsService.getJudges(eventId);
                commit('setJudges', Array.isArray(res.data) ? res.data : []);
            } finally {
                commit('setLoading', false);
            }
        },
        async fetchRounds({ commit, state }, eventId) {
            if (state.rounds.length) return;
            const nominationsService = (await import('@/services/nominations')).default;
            commit('setLoading', true);
            try {
                const res = await nominationsService.getRounds(eventId);
                commit('setRounds', Array.isArray(res.data) ? res.data : []);
            } finally {
                commit('setLoading', false);
            }
        },
        async reloadRounds({ commit }, eventId) {
            const nominationsService = (await import('@/services/nominations')).default;
            commit('setLoading', true);
            try {
                const res = await nominationsService.getRounds(eventId);
                commit('setRounds', Array.isArray(res.data) ? res.data : []);
            } finally {
                commit('setLoading', false);
            }
        }
    },
    getters: {
        judges(state) {
            return state.rounds.reduce((acc, r) => {
                (r.categories || []).forEach(c => {
                    (c.judges || []).forEach(j => {
                        if (!acc.some(x => x.id === j.id)) acc.push(j);
                    });
                });
                return acc;
            }, []);
        }
    }
};
